import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledSvg = styled.svg `
  fill: ${({ $inverted = false }) => ($inverted ? themeGet('colors.gray.0') : themeGet('colors.gray.1000'))};
`;
